import { QueryClient } from "@tanstack/react-query";

// For on-prem environments without internet access, the query client must be configured to keep making requests.
// Otherwise, after a single request fails, TanStack Query will stop sending further requests.
const isOfflineMode =
  import.meta.env.VITE_REACT_APP_OFFLINE_MODE !== undefined &&
  typeof import.meta.env.VITE_REACT_APP_OFFLINE_MODE === "string"
    ? import.meta.env.VITE_REACT_APP_OFFLINE_MODE.toLowerCase() === "true"
    : false;

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 1000 * 60 * 10,
      refetchOnWindowFocus: false,
      networkMode: isOfflineMode ? "always" : undefined,
    },
  },
});

export default queryClient;
